<script setup>
import MobileServiceInstitution from "@variants/seer/service-institution/m/index.vue";
import PcServiceInstitution from "@variants/seer/service-institution/pc/index.vue";

definePageMeta({
	"m-showNavBar": true,
	"m-showFooter": true,
	"pc-showNavBar": true,
	"pc-showFooter": true,
	keepalive: true,
	key: "service-institution-page",
	breadcrumbName: "服務機構",
});

useHead({
	title: "服務機構-先知命局",
	meta: [
		{
			name: "keywords",
			content: "服務機構,命理機構,身心靈療癒,道觀,寺廟,心理諮詢,先知命局",
		},
		{
			name: "description",
			content:
				"先知命局服務機構聚合全球優質命理、身心靈療癒、靈性修行與心理諮詢機構，為用戶提供可靠、透明、可預約的專業服務。",
		},
	],
});

const { $isMobile } = useNuxtApp();

// 服务机构首屏必须同步挂载，页面内部的真实数据骨架才能在路由切换后立即出现。
const Component = $isMobile ? MobileServiceInstitution : PcServiceInstitution;
</script>

<template>
	<Component />
</template>
